export default __webpack_public_path__ + "static/media/minturbol.45bf660f.png";